import React from 'react'
import {Icon} from '@chakra-ui/react'

const ScrollDownIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24ZM46.08 24C46.08 36.1945 36.1945 46.08 24 46.08C11.8056 46.08 1.92 36.1945 1.92 24C1.92 11.8056 11.8056 1.92 24 1.92C36.1945 1.92 46.08 11.8056 46.08 24Z"
                fill="currentColor"
            />
            <path
                d="M24.3393 26.0591L17.3381 19.1418L15.9805 20.4832L24.3393 28.7418L32.6981 20.4832L31.3405 19.1418L24.3393 26.0591Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ScrollDownIcon
